import { z } from 'zod';

/**
 * Scheme for AmplitudeWhitelistAction.
 */
const AmplitudeWhitelistActionScheme = z
  .object({
    guest: z.boolean().default(false),
    event: z.string().default('')
  })
  .passthrough()
  .default({});

/**
 * Scheme for Amplitude.
 */

export const AmplitudeScheme = z
  .object({
    apiKey: z.string().default(''),
    web: z
      .object({
        whitelist: z.array(AmplitudeWhitelistActionScheme).default([]),
        enabled: z.boolean().default(false),
        enableUserProperties: z.boolean().default(false),
        defaultEvents: z
          .object({
            attribution: z.boolean().default(false),
            pageViews: z.boolean().default(false),
            sessions: z.boolean().default(false),
            formInteractions: z.boolean().default(false),
            fileDownloads: z.boolean().default(false),
            elementInteractions: z.boolean().default(false)
          })
          .passthrough()
          .default({})
      })
      .passthrough()
      .default({})
  })
  .passthrough()
  .default({});

export type Amplitude = z.infer<typeof AmplitudeScheme>;
